/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTicketsRouteImport } from './routes/_app/tickets'
import { Route as AppInvoicesRouteImport } from './routes/_app/invoices'
import { Route as AppDriveRouteImport } from './routes/_app/drive'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects.index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects.$projectId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsRoute = AppTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesRoute = AppInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppDriveRoute = AppDriveRouteImport.update({
  id: '/drive',
  path: '/drive',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/drive': typeof AppDriveRoute
  '/invoices': typeof AppInvoicesRoute
  '/tickets': typeof AppTicketsRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/projects/': typeof AppProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/accept-invite': typeof AcceptInviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/drive': typeof AppDriveRoute
  '/invoices': typeof AppInvoicesRoute
  '/tickets': typeof AppTicketsRoute
  '/': typeof AppIndexRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/projects': typeof AppProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/drive': typeof AppDriveRoute
  '/_app/invoices': typeof AppInvoicesRoute
  '/_app/tickets': typeof AppTicketsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/login'
    | '/reset-password'
    | '/drive'
    | '/invoices'
    | '/tickets'
    | '/projects/$projectId'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invite'
    | '/login'
    | '/reset-password'
    | '/drive'
    | '/invoices'
    | '/tickets'
    | '/'
    | '/projects/$projectId'
    | '/projects'
  id:
    | '__root__'
    | '/_app'
    | '/accept-invite'
    | '/login'
    | '/reset-password'
    | '/_app/drive'
    | '/_app/invoices'
    | '/_app/tickets'
    | '/_app/'
    | '/_app/projects/$projectId'
    | '/_app/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets': {
      id: '/_app/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices': {
      id: '/_app/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/drive': {
      id: '/_app/drive'
      path: '/drive'
      fullPath: '/drive'
      preLoaderRoute: typeof AppDriveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDriveRoute: typeof AppDriveRoute
  AppInvoicesRoute: typeof AppInvoicesRoute
  AppTicketsRoute: typeof AppTicketsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDriveRoute: AppDriveRoute,
  AppInvoicesRoute: AppInvoicesRoute,
  AppTicketsRoute: AppTicketsRoute,
  AppIndexRoute: AppIndexRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
